export default __webpack_public_path__ + "static/media/bringg_logo.1cc91143.svg";